import { ViewModel } from '../../view-model';

export class InspectionReportTask implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'Inspection Report Task';
  readonly apiRoute: string;

  inspectionReportTaskId: string;
  frequencySource: string;
  inspectionPlanTaskId: string;
  inspectionReportId: string;
  taskName: string;
  isSelected: boolean;
  taskExtent: string;
  dueDate: string;
  mitigationType: string;
  mitigationSource: string;
  overrideFrequency: boolean;

  sendToErp: boolean;
  erpMaintenancePlanNumber: string;
  erpNotificationNumber: string;
  erpNotificationSystemStatus: string;
  erpWorkOrderNumber: string;
  erpWorkOrderSystemStatus: string;
  isErpEnabled: boolean;
  masterInspectionMethodId: string;

  public json(): any {
    return this;
  }

  public loadFromJson(data) {
    this.inspectionReportTaskId = data.inspectionReportTaskId;
    this.inspectionPlanTaskId = data.inspectionPlanTaskId;
    this.inspectionReportId = data.inspectionReportId;
    this.taskName = data.taskName;
    this.isSelected = data.isSelected;
    this.taskExtent = data.taskExtent;
    this.dueDate = data.dueDate;
    this.mitigationType = data.mitigationType;
    this.mitigationSource = data.mitigationSource;
    this.overrideFrequency = data.overrideFrequency;
    this.frequencySource = data.frequencySource;

    this.sendToErp = data.sendToErp;
    this.erpMaintenancePlanNumber = data.erpMaintenancePlanNumber;
    this.erpNotificationNumber = data.erpNotificationNumber;
    this.erpNotificationSystemStatus = data.erpNotificationSystemStatus;
    this.erpWorkOrderNumber = data.erpWorkOrderNumber;
    this.erpWorkOrderSystemStatus = data.erpWorkOrderSystemStatus;
    this.isErpEnabled = data.isErpEnabled;
    this.masterInspectionMethodId = data.masterInspectionMethodId;
  }
}
